import { IWisDetailsModalContentRowProps } from './types'

export const WisDetailsModalRow = ({
  name,
  value,
  withBorder
}: IWisDetailsModalContentRowProps) => (
  <div className={`mb-2 pb-2 ${withBorder ? 'border-b border-gray-300' : ''}`}>
    <div className='flex'>
      <span className='font-semibold pr-4 basis-40'>{name}</span>
      <span className='flex-1 basis-64'>{value}</span>
    </div>
  </div>
)

export default WisDetailsModalRow
